// extracted by mini-css-extract-plugin
export default {"overAll":"centerview_overAll__3iSHH","content":"centerview_content__ybVVD"};